import React from 'react';
import HomePage from './page/Home/HomePage';
import ModalContact from './components/ModalContact/ModalContact';
import LeadOriginTracker from './components/LeadOriginTracker/LeadOriginTracker';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import './App.css';
import ParaAlunos from './page/ParaAlunos/ParaAlunos';

function App() {
  const [showModal, setShowModal] = React.useState(false)

  return (
    <GoogleReCaptchaProvider
      type="v3"
      siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    >
      <LeadOriginTracker />
      <BrowserRouter>
        <div className="App">
          {showModal &&
            <ModalContact setShowModal={setShowModal} />
          }
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/para-alunos' element={<ParaAlunos />} />
          </Routes>
        </div>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  )
}

export default App;
